import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import axios from 'axios';
import { useSettings } from '../context/SettingsContext';
import { formatCurrency } from '../utils/currency';
import { LoadingState } from '../components/Loading';
import { FaShoppingBag, FaArrowRight } from 'react-icons/fa';

const STATUS_BADGE = {
  pending: 'warning',
  processing: 'info',
  shipped: 'info',
  delivered: 'success',
  cancelled: 'danger',
};

const MyOrders = () => {
  const { settings } = useSettings();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadOrders();
  }, []);

  const loadOrders = async () => {
    try {
      const res = await axios.get('/api/orders');
      setOrders(res.data);
    } catch (e) { console.error(e); }
    finally { setLoading(false); }
  };

  if (loading) return <div className="page"><LoadingState /></div>;

  return (
    <div className="page">
      <div className="container">
        <h1 style={{ fontFamily: 'var(--font-display)', fontSize: 32, marginBottom: 4 }}>
          My orders
        </h1>
        <p className="page-subtitle" style={{ marginBottom: 32 }}>
          {orders.length === 0
            ? 'You have no orders yet'
            : `${orders.length} ${orders.length === 1 ? 'order' : 'orders'} placed`}
        </p>

        {orders.length === 0 ? (
          <div className="empty-state">
            <FaShoppingBag className="empty-state-icon" />
            <h3>No orders yet</h3>
            <p>When you place your first order, it'll appear here.</p>
            <Link to="/products" className="btn btn-primary">
              Start shopping <FaArrowRight />
            </Link>
          </div>
        ) : (
          <div style={{ display: 'flex', flexDirection: 'column', gap: 16 }}>
            {orders.map((order) => (
              <Link
                key={order._id}
                to={`/my-orders/${order._id}`}
                className="card"
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                  flexWrap: 'wrap',
                  gap: 16,
                  textDecoration: 'none',
                  transition: 'var(--transition)',
                }}
                onMouseEnter={(e) => e.currentTarget.style.boxShadow = 'var(--shadow-md)'}
                onMouseLeave={(e) => e.currentTarget.style.boxShadow = 'var(--shadow-sm)'}
              >
                <div>
                  <div style={{ fontSize: 12, color: 'var(--gray-500)', marginBottom: 4 }}>
                    Order placed {new Date(order.createdAt).toLocaleDateString()}
                  </div>
                  <div style={{ fontWeight: 700, fontSize: 16, marginBottom: 4 }}>
                    {order.orderNumber}
                  </div>
                  <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                    <span className={`badge ${STATUS_BADGE[order.status] || 'neutral'}`}>
                      {order.status}
                    </span>
                    <span style={{ fontSize: 13, color: 'var(--gray-500)' }}>
                      · {order.items.length} {order.items.length === 1 ? 'item' : 'items'}
                    </span>
                  </div>
                </div>

                <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
                  <div style={{ fontWeight: 700, fontSize: 18 }}>
                    {formatCurrency(order.total, settings?.currency)}
                  </div>
                  <FaArrowRight style={{ color: 'var(--gray-400)' }} />
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default MyOrders;
